import { useState, useLayoutEffect, Fragment } from 'react';
import ServiceDirectoryMenu from '../../components/ServiceDirectoryMenu/ServiceDirectoryMenu';
import TextInformation from '../../components/TextInformation/TextInformation';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MediumHeightDivider, SmallHeightDivider } from '../../theme/Styles';
import { Row, RowBodyDivider } from '../../theme/Styles';
import { Grid } from '@mui/material';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import { useHistory } from 'react-router';
import LoginOrRegisterModal from '../../components/LoginOrRegisterModal/LoginOrRegisterModal';
import { useDispatch, useSelector } from "react-redux";
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import { useParams } from "react-router-dom";
import {
    Container,
} from './styles/AllServicesStyles';
import { getAllServices, getGeneralInformationsFromWordpress } from '../../api/ListOfServicesPerCategory';
import { getAlcaldias } from '../../api/Alcaldia';
import { useQuery } from 'react-query';
import CenterLoading from '../../components/CenterLoading/CenterLoading';

function AllServices() {

    const matchesWidth = useMediaQuery('(min-width:768px)');
    const history = useHistory();
    let { categoryID } = useParams();
    const dispatch = useDispatch();
    const { authenticated } = useSelector((state) => state.authReducer);

    const { data: generalInformationData, isLoading: generalInformationDataLoading } = useQuery(['generalInformationData'], () => getGeneralInformationsFromWordpress())
    const { data: listOfServices, isLoading: listOfServicesLoading } = useQuery(['listOfServices'], () => getAllServices())
    const { data: alcaldias, isLoading: alcaldiasLoading } = useQuery(['alcaldias'], () => getAlcaldias(), { staleTime: 0, cacheTime: 0 })

    const [loginOrRegisterModalStatus, setLoginOrRegisterModalStatus] = useState(false);

    const handleServiceRequest = (service) => {
        if (authenticated) {
                history.push(`/app/requestService/${service.id}`)
        } else {
            setLoginOrRegisterModalStatus(!loginOrRegisterModalStatus);
        }
    }

    useLayoutEffect(() => {
        // TITLE OF SUBHEADER APP
        dispatch(UpdateAppSubHeaderTitle("Todos los trámites"))
    }, []);

    if (generalInformationDataLoading || listOfServicesLoading) return <CenterLoading />

    return (
        <Container >
            <LoginOrRegisterModal open={loginOrRegisterModalStatus} onBackDropClick={() => setLoginOrRegisterModalStatus(false)} onCloseClick={() => setLoginOrRegisterModalStatus(false)} />
            <Row>
                {
                    matchesWidth &&
                    <Fragment>
                        <ServiceDirectoryMenu />
                        <RowBodyDivider />
                    </Fragment>
                }

                <Container style={{ width: '100%' }}>
                    <TextInformation title="Información general" content={
                        generalInformationData?.find((item) => item.id == 0 )?.descriptionGeneral
                    } />
                    <SmallHeightDivider />

                    {
                        listOfServices?.map((item) => (
                            <Fragment key={item.id}>
                                <TextInformation title={item.name} />
                                <SmallHeightDivider />
                                <Grid alignItems="center" container direction="row" justifyContent={!matchesWidth ? "center" : "flex-start"} spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                                    {
                                        item.services?.map((service) => (
                                            <Grid key={service.id} item>
                                                <ServiceCard itemId={service.id}
                                                    title={service.name}
                                                    subTitle={service.description}
                                                    relationTo={item.name}
                                                    onRequestPress={() => handleServiceRequest(service)}
                                                    disableRequestButton={service.type_id === 1 ? true:false}
                                                    OnViewInformationPress={() => history.push(`/app/serviceDescription/${service.id}`)} />
                                            </Grid>
                                        ))
                                    }
                                </Grid>
                                <MediumHeightDivider />
                            </Fragment>
                        ))
                    }

                    {alcaldias && alcaldias.length > 0 && (
                        <Fragment>
                            <TextInformation title="Ayuntamientos" />
                            <SmallHeightDivider />
                            <Grid alignItems="center" container direction="row" justifyContent={!matchesWidth ? "center" : "flex-start"} spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                                {alcaldias.map((alcaldia) => (
                                    <Grid key={alcaldia.id} item>
                                        <ServiceCard
                                            title={alcaldia.name}
                                            subTitle={alcaldia.description || alcaldia.municipality}
                                            relationTo="Ayuntamientos"
                                            imageUrl={alcaldia.logo_url || null}
                                            onRequestPress={() => history.push(`/app/alcaldias/${alcaldia.institution_id || alcaldia.id}`)}
                                            OnViewInformationPress={() => history.push(`/app/alcaldias/${alcaldia.institution_id || alcaldia.id}`)}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                            <MediumHeightDivider />
                        </Fragment>
                    )}

                    <MediumHeightDivider />
                </Container>
            </Row>
        </Container>
    );
}

export default AllServices;
